import React from "react";
import {
	StyleSheet,
	View
} from "react-native";

import {Document, Page} from "react-pdf/dist/entry.webpack";
import Navigator from "./Navigator";

import Style from "ae-style";

const styles = StyleSheet.create({
	container: {
		flex: 1,
		alignSelf: "stretch"
	},
	page: {
		paddingVertical: Style.layout.paddingSlim
	}
});

export default class PDFViewerWeb extends React.PureComponent {
	constructor(props){
		super(props);
		this.state = {
			start: 0,
			pages: []
		};

		this.onDocumentLoadSuccess = onDocumentLoadSuccess.bind(this);
	}

	render(){
		const {pages} = this.state;
		const renderPages = pages.map((page) => {
			return (
				<View style={styles.page}>
					<Page
							renderTextLayer={false}
							width={this.props.width}
							pageNumber={page} />
				</View>
			);
		});

		return (
			<View style={styles.container}>
				<Navigator url={this.props.url} back={this.props.back} fullscreen={this.props.fullscreen} noDownload={this.props.noDownload} />
				<Document
					file={this.props.url}
					onLoadSuccess={this.onDocumentLoadSuccess}
					options={{isEvalSupported: false}}>
					{renderPages}
				</Document>
			</View>
		);
	}
}

function onDocumentLoadSuccess({numPages}){
	const pages = Array.from(Array(numPages), (key, index) => 1 + index);
	this.setState({pages});
}
